import {
  FaqContainer,
  FaqHeader,
  FaqBadge,
  NavLink,
  NavLinksContainer,
  FaqTitle,
  QuestionButtons,
  QuestionButton,
  AnswerContainer,
} from "./FAQ.styled";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box/Box";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import Timer from "../../stores/TimerModalStore";
import { useState, useEffect } from "react";
import General from "../../stores/GeneralStore";
const CustomExpandIcon = () => {
  return (
    <Box
      sx={{
        ".Mui-expanded & > .collapsIconWrapper": {
          display: "none",
        },
        ".expandIconWrapper": {
          display: "none",
        },
        ".Mui-expanded & > .expandIconWrapper": {
          display: "block",
        },
      }}
    >
      <div className="expandIconWrapper">
        <RemoveIcon />
      </div>
      <div className="collapsIconWrapper">
        <AddIcon />
      </div>
    </Box>
  );
};

const FaqPage = () => {
  const [data, setData] = useState([]);
  const timer = new Timer();

  useEffect(() => {
    timer.getFAQ(setData);
  }, []);
  return (
    <>
      <FaqHeader>
        <NavLinksContainer>
          <NavLink to="/">
            {General?.codeLabels["cm_home"]?.label !== undefined ? General?.codeLabels["cm_home"]?.label : " Home"}
          </NavLink>&nbsp; /&nbsp;
          <NavLink to="/">Our Services</NavLink>&nbsp; / &nbsp;
          <NavLink to="/">

            {General?.codeLabels["cm_mob_frqntqstns"]?.label !== undefined ? General?.codeLabels["cm_mob_frqntqstns"]?.label : "Frequently Asked Questions"}
          </NavLink>
        </NavLinksContainer>
        <FaqTitle>            {General?.codeLabels["cm_mob_frqntqstns"]?.label !== undefined ? General?.codeLabels["cm_mob_frqntqstns"]?.label : "Frequently Asked Questions"}
        </FaqTitle>
        <FaqBadge>
          <b>
            Find answers to all your questions about our services, payments,
            fees and other topics.
          </b>
        </FaqBadge>
      </FaqHeader>
      <FaqContainer>
        <QuestionButtons>
          <QuestionButton>
            <b>All</b>
            <NavigateNextIcon />
          </QuestionButton>
          <QuestionButton>
            <b>Website and App</b>
            <NavigateNextIcon />
          </QuestionButton>
          <QuestionButton>
            <b>
              {General?.codeLabels["cm_payments"]?.label !== undefined ? General?.codeLabels["cm_payments"]?.label : "Payments"}

            </b>
            <NavigateNextIcon />
          </QuestionButton>
          <QuestionButton>
            <b>            
              {General?.codeLabels["cm_services"]?.label !== undefined ? General?.codeLabels["cm_services"]?.label : "Services"}
            </b>
            <NavigateNextIcon />
          </QuestionButton>
        </QuestionButtons>
        <AnswerContainer>
          {data.map((question: any, index: any) => (
            <Accordion
              key={index}
              sx={{
                border: "none",
                boxShadow: "none",
                fontSize: "0.8rem",
                width: "100%",
                "$:before": {
                  background: "transparent !important",
                  border: "none",
                },
              }}
            >
              <AccordionSummary
                expandIcon={<CustomExpandIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography sx={{ fontWeight: "700", color: "#101e8e" }}>
                  {question.question}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>{question.answer}</Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </AnswerContainer>
      </FaqContainer>
    </>
  );
};

export default FaqPage;
